// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KuWnY","option":"styles_option__XXbgk","active":"styles_active__3rM_K"};